'use strict';

class YaMapGeography {
    _map;
    _objectManager;
    _placemarks;
    _params;

    constructor(e, placemarks, params) {
        this.e = e;
        this._placemarks = placemarks;
        this._params = params;
    }

    render() {
        ymaps.ready(() => {
            this._objectManager = this._setObjectManager(this._params.clickCallback);
            this._setIconLayout(this._placemarks);
            this._map = this._setMap();
        });
    }

    setBounds(map) {
        map.setBounds(this._objectManager.getBounds(), {
            checkZoomRange: true,
            duration: 500,
            useMapMargin: true
        });
    }

    filter(filters) {

        this._objectManager.setFilter(this._getFilterStatus(filters));

        let result_filter = this._objectManager.objects.getAll().filter((x) => {
            //return true;
            return !this._objectManager.getObjectState(x.id).isFilteredOut;
        })

        return result_filter;
    }

    _getFilterStatus(filters) {
        return function (placemark) {
            let status = false;
            let match_count = 0;
            let filter_count = Object.keys(filters).length;

            for (let i in filters) {
                if (filters[i] === +placemark.company[i]) {
                    match_count++;
                }
            }

            if (filter_count === match_count) {
                status = true;
            }

            return status;
        }
    }

    getMap() {
        return this._map;
    }

    _setIconLayout() {
        let iconLayout = ymaps.templateLayoutFactory.createClass('<div id="{{ id }}" class="{{ class }}"></div>');

        this._objectManager.objects.options.set({
            iconLayout: iconLayout,
            iconShape: {
                type: 'Circle',
                coordinates: [0, 0],
                radius: 42
            }
        });
    }

    _setObjectManager(callback) {
        let objectManager = new ymaps.ObjectManager({clusterize: true}).add(this._placemarks);

        objectManager.clusters.options.set({preset: 'islands#redClusterIcons'});

        if (callback) {
            objectManager.objects.events.add(['click'], function (e) {
                callback(e);
            });
        }
        if (window.location.hash === '#fivepost') {
            objectManager.setFilter(function (object) {
                return object.company.parent == '5 ПОСТ';
            });
        }
        return objectManager;
    }


    _setMap() {
        let map = new ymaps.Map(this.e, {
                center: [this._params.center.lat, this._params.center.lon],
                zoom: this._params.zoom,
                avoidFractionalZoom: false,
                controls: []
            }, {
                autoFitToViewport: 'always',
            }
        );


        //map.behaviors.disable('scrollZoom');
        //map.behaviors.disable('drag');

        map.controls.add('zoomControl', {position: {right: '20px', top: '100px'}});

        map.geoObjects.add(this._objectManager);

        this.setBounds(map);

        $('[class *="-ground-pane"]').addClass('grayscale'); //Делаем карту черно-белой

        var filterBoxLayout = ymaps.templateLayoutFactory.createClass(
            "<div class=\"btn btn-primary\" ><span class=\"glyphicon glyphicon-filter\"></span> {{ data.title }}</div ><div id=\"filter-listbox\" style=\"background:white; padding:10px; display: {% if state.expanded %}block{% else %}none{% endif %};\" >" +
            '</div >', {

                build: function () {
                    filterBoxLayout.superclass.build.call(this);
                    this.childContainerElement = $('#filter-listbox').get(0);
                    // Каждый раз, когда мы перестраиваемся, мы генерируем событие
                    // это означает, что контейнер для дочерних элементов изменился.
                    // Формат события описан в интерфейсе IGroupControlLayout.
                    this.events.fire('childcontainerchange', {
                        newChildContainerElement: this.childContainerElement,
                        oldChildContainerElement: null
                    });
                },

                // Переопределим метод, который требует интерфейс IGroupControlLayout.
                getChildContainerElement: function () {
                    return this.childContainerElement;
                }
            }
        );
        var listBoxItems = ['КИТ.ТК', '5 ПОСТ', 'ПВЗ']
                .map(function (title) {

                    if (window.location.hash === '#fivepost') {
                        if (title == '5 ПОСТ') {
                            return new ymaps.control.ListBoxItem({
                                data: {
                                    content: title
                                },
                                state: {
                                    selected: true
                                }
                            })
                        } else {
                            return new ymaps.control.ListBoxItem({
                                data: {
                                    content: title
                                },
                                state: {
                                    selected: false
                                }
                            })

                        }
                    } else {
                        return new ymaps.control.ListBoxItem({
                            data: {
                                content: title
                            },
                            state: {
                                selected: true
                            }
                        })
                    }
                }),

            reducer = function (filters, filter) {
            filters[filter.data.get('content')] = filter.isSelected();
            return filters;
            },
            // Теперь создадим список, содержащий 5 пунктов.
            listBoxControl = new ymaps.control.ListBox({
                data: {
                    content: 'Фильтр',
                    title: 'Фильтр'
                },
                options: {
                    float: 'left',
                    layout: filterBoxLayout
                },
                items: listBoxItems,
                state: {
                    // Признак, развернут ли список.
                    expanded: false,
                    filters: listBoxItems.reduce(reducer, {})
                }
            });
        map.controls.add(listBoxControl);
        listBoxControl.events.add(['select', 'deselect'], function (e) {
            var listBoxItem = e.get('target');
            var filters = ymaps.util.extend({}, listBoxControl.state.get('filters'));
            filters[listBoxItem.data.get('content')] = listBoxItem.isSelected();
            listBoxControl.state.set('filters', filters);
        });
        var filterMonitor = new ymaps.Monitor(listBoxControl.state);
        var the = this, objectManager = this._objectManager;
        filterMonitor.add('filters', function (filters) {
            // Применим фильтр.
            objectManager.setFilter(the.getFilterFunction(filters));
        });

        return map;
    }

    getFilterFunction = function (categories) {
        return function (obj) {
            var content = obj.company.parent;
            var code = obj.company.code;
            $('[name="parent_filter[' + code + ']"]').prop('checked', categories[content]);
            if (!categories[content]) {
                $('[name="parent_filter[' + code + ']"]').removeAttr('checked')
            }
            return categories[content];
        }
    }
}

